module.exports = __webpack_public_path__ + "assets/ee16c86786aaa687c594aebafdd4ad9a.png";